import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { useFormikContext } from "formik";
import Filter from "library/Molecules/Filter";
import Menu from "library/Molecules/Menu";
import { useCallback, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { prettifyStatusLabel } from "utility/helpers/general";
import { PAYMENT_STATUSES_LIST, PENDING_PAYMENT_STATUS } from "../../../../constants";

const PaymentStatusFilter = () => {
  const { t } = useTranslation();

  const {
    values: { paymentStatus = "all" },
    setFieldValue,
  } = useFormikContext();

  const paymentStatusFilterRef = useRef();

  const options = useMemo(() => {
    const restOptions = PAYMENT_STATUSES_LIST.filter((s) => s !== PENDING_PAYMENT_STATUS).map((value) => {
      return { label: t([`utils.paymentStatuses.${value}`, prettifyStatusLabel(value)]), value };
    });
    return [{ label: t("features.filtersForm.filterPlaceholder"), value: "all" }, ...restOptions];
  }, [t]);

  const handleChangeStatus = useCallback(
    (value) => {
      paymentStatusFilterRef.current?.closeMenu?.();
      if (paymentStatus === value) return;
      setFieldValue("paymentStatus", value);
    },
    [paymentStatus, setFieldValue]
  );

  return (
    <Filter
      ref={paymentStatusFilterRef}
      badge={paymentStatus !== "all"}
      icon={<CreditCardOutlinedIcon fontSize="small" />}
    >
      <>
        <Menu.MenuItem className="mx-3 mb-2" disabled>
          {t("features.filtersForm.paymentStatusFilterPlaceholder")}
        </Menu.MenuItem>

        {options.map(({ label, value }) => (
          <Menu.MenuItem
            key={value}
            selected={paymentStatus === value}
            onClick={() => handleChangeStatus(value)}
            aria-selected={paymentStatus === value}
          >
            <span className="text-fs-12 pl-3">{label}</span>
          </Menu.MenuItem>
        ))}
      </>
    </Filter>
  );
};

export default PaymentStatusFilter;
